import React from 'react';
import classNames from 'classnames';

import { Outlet } from "react-router-dom";
import LayoutType from 'src/shared/utils/layout_type';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';

import { HeroUIProvider, ToastProvider } from '@heroui/react';
import 'react-modern-drawer/dist/index.css'

const MainLayout = ({layoutType = LayoutType.FRONT_SITE}) => {
  return (
    <HeroUIProvider>
      <div className={classNames("ligth text-foreground main-layout min-h-screen flex flex-col", {
        'bg-background': layoutType !== LayoutType.CHECKOUT,
        'bg-[#F6F9FC]': layoutType === LayoutType.CHECKOUT,
      })}>
        <Header layoutType={layoutType} />
        <main className="flex-grow">
          <Outlet />
        </main>
        <Footer layoutType={layoutType} />
      </div>
      <ToastProvider placement="top-right" defaultOptions={{ duration: 5000 }} toastOffset={90}/>
    </HeroUIProvider>
  );
};

export default MainLayout;
